import { Reducer } from "react"
import { handleActions } from "redux-actions"
import { ACTION_GETEXPORTTASKLIST_SUCCESS } from "../../actions/silizhu/statistics";

export interface silizhuStatisticsState {
    ExportTaskList: any;
}

const initialState: silizhuStatisticsState = {
    ExportTaskList: [],
}

function handleActionGetExportTaskListSuccess(state: silizhuStatisticsState, action): silizhuStatisticsState {
    console.log(`ACTION: ${action.type}`);
    return {
        ...state,
        ExportTaskList: action.payload.ExportTaskList,
    };
}

export const silizhuStatisticsReducer: Reducer<silizhuStatisticsState, any> = handleActions(
    {
        [ACTION_GETEXPORTTASKLIST_SUCCESS]: handleActionGetExportTaskListSuccess,
    },
    initialState
);